import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';

import videos from 'widget/redux/client/reducers/videos';
import channels from 'widget/redux/client/reducers/channels';
import channelVideos from 'widget/redux/client/reducers/channel-videos';

import configuration from 'widget/redux/client/reducers/configuration';
import appSettings from 'widget/redux/client/reducers/app-settings';
import currentChannelId from 'widget/redux/client/reducers/current-channel-id';
import search from 'widget/redux/client/reducers/search';
import channelInfo from 'widget/redux/client/reducers/channel-info';
import currentSiteUser from 'widget/redux/client/reducers/current-site-user';
import firstChannelVideoId from 'widget/redux/client/reducers/first-channel-video-id';
import biDefaultParams from 'widget/redux/client/reducers/bi-default-params';
import shareOverlay from 'widget/redux/client/reducers/share-overlay';
import videoUrlsCache from 'widget/redux/client/reducers/video-urls-cache';
import selectedVideoId from 'widget/redux/client/reducers/selected-video-id';
import player from 'widget/redux/client/reducers/player';
import isVideosTouched from 'widget/redux/client/reducers/is-videos-touched';
import experiments from 'shared/redux/client/reducers/experiments';
import vodSettings from 'shared/redux/client/reducers/vod-settings';
import videoCards from 'widget/redux/client/reducers/video-cards/video-cards';
import payment from 'widget/redux/client/reducers/payment';
import lazyChannelVideos from 'widget/redux/client/lazy-channel-videos/reducer';
import windowSize from 'widget/redux/client/reducers/window-size';
import isLightbox from 'widget/redux/client/reducers/is-lightbox';
import fullScreenModal from 'widget/redux/client/reducers/full-screen-modal';
import comments from 'widget/redux/client/reducers/comments';

export const widgetReducers = {
  routing,
  search,
  entities: combineReducers({
    videos,
    channels,
  }),
  channelVideos,
  currentChannelId,
  channelInfo,
  currentSiteUser,
  firstChannelVideoId,

  lazyChannelVideos,
  windowSize,
  isLightbox,

  videoUrlsCache,
  selectedVideoId,
  player,
  isVideosTouched,
  payment,

  configuration,
  appSettings,
  experiments,
  vodSettings,
  biDefaultParams,
  videoCards,
  shareOverlay,

  fullScreenModal,
  comments,
};

export default combineReducers(widgetReducers);
